import React from 'react';
import PropTypes from 'prop-types';
import times from 'times.svg';
import chevron from 'chevron-blue.svg';

export default function AdditionalImage({
  src,
  index,
  clearImage,
  firstImage,
  lastImage,
  orderImage,
  alt = '',
}) {
  return (
    <div className="upload-additional-image-outer">
      <button
        className="remove-additional-image"
        type="button"
        onClick={clearImage}
      >
        <img src={times} alt="" />
      </button>

      <div className="order-buttons-container">
        {!firstImage && (
          <button
            type="button"
            onClick={() => orderImage(index, 'forwards')}
            className="order-button forward"
          >
            <img src={chevron} alt="" />
          </button>
        )}

        {!lastImage && (
          <button
            type="button"
            onClick={() => orderImage(index, 'backwards')}
            className="order-button backward"
          >
            <img src={chevron} alt="" />
          </button>
        )}
      </div>

      <img src={src} alt={alt} />
    </div>
  );
}

AdditionalImage.propTypes = {
  src: PropTypes.string.isRequired,
  index: PropTypes.number.isRequired,
  clearImage: PropTypes.func.isRequired,
  orderImage: PropTypes.func.isRequired,
  firstImage: PropTypes.bool,
  lastImage: PropTypes.bool,
  alt: PropTypes.string,
};
